import PayMonthlyCompensate from '@/api/hr/pay-monthly-compensate'
import Employee from '@/api/hr/employee'
import Compensate from '@/api/hr/pay-item-compensate'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  cycle_year: moment().format('YYYY'),
  cycle_month: moment().format('MM'),
  employees: [],
  compensates: [],
  itemCompensates: [],
  employeeCompensateLists: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_COMPENSATES(state, compensates) {
    state.compensates = compensates
  },
  RECEIVE_ITEM_COMPENSATES(state, data) {
    state.itemCompensates = data
  },
  RECEIVE_EMPLOYEE_COMPENSATE_LISTS(state, data) {
    state.employeeCompensateLists = data
  },
  SET_CYCLE_YEAR(state, data) {
    state.cycle_year = data
  },
  SET_CYCLE_MONTH(state, data) {
    state.cycle_month = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_month: context.state.cycle_month,
        cycle_year: context.state.cycle_year,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayMonthlyCompensate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayMonthlyCompensate.store(data)
  },

  generate(context, data) {
    return PayMonthlyCompensate.importCompensate(data)
  },

  update(context, { id, ...data }) {
    return PayMonthlyCompensate.update(id, data)
  },

  destroy(context, id) {
    return PayMonthlyCompensate.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchCompensates(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_compensate: 'compensate_id,compensate_item'
      },
      ...attributes
    }

    return Compensate.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_COMPENSATES', response.data)
      return Promise.resolve(response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.itemCompensates.length > 0) {
      let response = await PayMonthlyCompensate.getItemCompensate()
      context.commit('RECEIVE_ITEM_COMPENSATES', response.data)
    }
  },
  fetchEmployeeCompensateList(context, params = {}) {
    return PayMonthlyCompensate.getEmployeeCompensateList({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEE_COMPENSATE_LISTS', response.data)
      return Promise.resolve(response)
    })
  }
}
